(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393],{

/***/ 16161:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/[slug]",
      function () {
        return __webpack_require__(34978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
;// CONCATENATED MODULE: ./components/Products/FeatureBox.tsx



const FeatureBox = (param)=>{
    let { title , desc , icon  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Products_module_default()).featureBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Products_module_default()).featureBoxIcon,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Products_module_default()).featureBoxText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy2",
                        emphasis: true,
                        className: "text-white",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        className: "text-color-darker-copy-on-dark",
                        children: desc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Products_FeatureBox = (FeatureBox);

// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx + 2 modules
var HighlightCodeBlock = __webpack_require__(96736);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./public/images/products-errors.png
/* harmony default export */ var products_errors = ({"src":"/_next/static/media/products-errors.a1af7f1b.png","height":808,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJ1BMVEUOAycNBypOT28OBSgSDC0YES4WDTFMaXFAOGZNTIp0YqxpdJcxS3wgqgKxAAAADXRSTlPUJBODNAiMAEEnJTYh6QsZRAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACxJREFUCJkdwQkOACAIA7AxjgH6//ea2EK7JFPQnDOXQnZ3mCWsqtzdEPjiARUuAL80UQ7AAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/products-graph.png
/* harmony default export */ var products_graph = ({"src":"/_next/static/media/products-graph.a45327f6.png","height":801,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEULACQQBSgOBigyKk4UCCoqHk80KFQWFTcNASQhH0AmGUcnGUU3K10PBCcQDzIJvxO1AAAADnRSTlP9xuMo1EWq2J39hIlh8YDZQSMAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAArSURBVAiZLcHBEQAgCAOwtoCAeuw/rh8TmJkVWYi4oRlhr3WyO0F3ukR8ehLVALAX9Wg1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/products-replay.png
/* harmony default export */ var products_replay = ({"src":"/_next/static/media/products-replay.50f0acc5.png","height":759,"width":1140,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEUcEzgkJkwbGj4OAycXDTAlHD4A3xK9AAAAA3RSTlP+8fGCMYhyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImS3EgQkAMAjEwKj5/VeWFnMQ5uIPBlWCmKBAdz21CZoAY3YJ4kwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./pages/index.tsx + 15 modules
var pages = __webpack_require__(61320);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./components/Home/Reviews.ts + 5 modules
var Reviews = __webpack_require__(83620);
// EXTERNAL MODULE: ./components/Products/InfoRow.tsx
var InfoRow = __webpack_require__(15099);
// EXTERNAL MODULE: ./public/images/hero-bug-left.gif
var hero_bug_left = __webpack_require__(17565);
// EXTERNAL MODULE: ./public/images/hero-bug-right.gif
var hero_bug_right = __webpack_require__(52417);
;// CONCATENATED MODULE: ./pages/for/[slug].tsx


























const Products = (param)=>{
    let { product  } = param;
    const reviewsRef = (0,react.useRef)(null);
    const scrollYPosition = (0,react.useRef)(0);
    const [scrollReviews, setScrollReviews] = (0,react.useState)(false);
    const [leftBugLoaded, setLeftBugLoaded] = (0,react.useState)(false);
    const [rightBugLoaded, setRightBugLoaded] = (0,react.useState)(false);
    const scrollListener = (0,react.useCallback)(()=>{
        if (!scrollReviews) {
            return;
        }
        if (reviewsRef.current) {
            const { scrollY  } = window;
            const scrollingDown = scrollYPosition.current > scrollY;
            // Adjust this value to control scroll speed
            const scrollDistance = scrollingDown ? -3 : 3;
            reviewsRef.current.scrollLeft += scrollDistance;
            scrollYPosition.current = scrollY;
        }
    }, [
        scrollReviews
    ]);
    (0,react.useEffect)(()=>{
        window.removeEventListener("scroll", scrollListener);
        window.addEventListener("scroll", scrollListener);
        return ()=>window.removeEventListener("scroll", scrollListener);
    }, [
        scrollListener
    ]);
    (0,react.useEffect)(()=>{
        const reviewsElement = reviewsRef.current;
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setScrollReviews(entry.isIntersecting);
        }, {
            root: null,
            rootMargin: "250px 0px",
            threshold: 0
        });
        if (reviewsElement) {
            observer.observe(reviewsElement);
            // Scroll to center on load
            reviewsElement.scrollLeft = (reviewsElement.scrollWidth - window.innerWidth) / 2;
        }
        return ()=>{
            if (reviewsElement) {
                observer.unobserve(reviewsElement);
            }
        };
    }, [
        reviewsRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                hideBanner: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Home_module_default()).heroVideoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugLeft */.ds, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_left/* default */.Z,
                                        alt: "bug left",
                                        onLoadingComplete: ()=>setLeftBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugRight */.nw, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_right/* default */.Z,
                                        alt: "bug right",
                                        onLoadingComplete: ()=>setRightBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorFeature,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Home_module_default()).anchorHead,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                "The ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Home_module_default()).highlightedText,
                                                    children: product.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "monitoring toolkit ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                    className: "hidden sm:flex"
                                                }),
                                                "you've been waiting ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                    className: "hidden sm:flex"
                                                }),
                                                "for."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 sm:mt-8 px-4 max-w-[840px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                type: "copy1",
                                                onDark: true,
                                                children: [
                                                    "What if monitoring your ",
                                                    product.title,
                                                    " app was as easy as deploying it? With session replay and error monitoring, Highlight's got you covered."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center my-14",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col sm:flex-row justify-center gap-4 w-screen sm:w-auto px-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        className: classnames_default()((Home_module_default()).solidButton, "min-w-[180px]"),
                                                        href: "https://app.highlight.io/sign_up",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Get started"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: "/docs",
                                                        className: classnames_default()((Products_module_default()).hollowButton),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Read our docs"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mb-20 md:mb-[160px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:flex-row justify-center gap-4 px-4 lg:gap-12 lg:px-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Session Replay",
                                    desc: "Investigate hard-to-crack bugs by playing through issues in a youtube-like UI. With access to requests, console logs and more!",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsPlayCircleFill */.rUT, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Error Monitoring",
                                    desc: "Continuously monitor errors and exceptions in your ".concat(product.title, " application,\n                    all the way from your frontend to your backend."),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsFillTerminalFill */.NV3, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Performance Metrics",
                                    desc: "Monitor and set alerts for important performance metrics in ".concat(product.title, "\n                    like Web Vitals, Request latency, and much more!"),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsBarChartFill */.oh2, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center bg-color-primary-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Products_module_default()).anchorFeature,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Home_module_default()).anchorHead,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Products_module_default()).subtleBadge,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                type: "copy4",
                                                emphasis: true,
                                                children: [
                                                    "Highlight for ",
                                                    product.title
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    "Get started in your ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                        className: "hidden sm:flex"
                                                    }),
                                                    product.title,
                                                    " app ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "today."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center my-14",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col lg:flex-row justify-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: "https://app.highlight.io/sign_up",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Get started for free"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: product.docsLink,
                                                        className: (Products_module_default()).hollowButton,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Read our docs"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-4/5 mb-20 md:mb-40",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock/* HighlightCodeBlock */.d, {
                                        language: "js",
                                        product: product,
                                        showLineNumbers: false,
                                        topbar: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Products_module_default()).infoContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Reproduce issues with high-fidelity session replay.",
                                desc: "With our pixel-perfect replays of your ".concat(product.title, " app,\n            you'll get to the bottom of issues in no time and better\n            understand how your app is being used."),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_replay
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Products_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Get a ping when exceptions or errors are thrown.",
                                desc: "Our alerting infrastructure can take abnormal metrics or\n            errors raised in your ".concat(product.title, " app and notify your\n            engineering team over Slack, Discord, and more!"),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_errors,
                                invert: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Products_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Monitor the metrics that keep your customers around.",
                                desc: "Highlight allows you to track performance, request timings, and several other metrics\n            in your ".concat(product.title, " application."),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_graph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    onDark: true,
                                    children: [
                                        "Don't take our word. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customers",
                                            children: "What our customers have to say →"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).slider,
                        ref: reviewsRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).slideTrack,
                            children: [
                                ...Reviews/* REVIEWS */.t,
                                ...Reviews/* REVIEWS */.t
                            ].map((review, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(pages.CustomerReview, {
                                    companyLogo: review.companyLogo,
                                    text: review.text,
                                    author: review.author,
                                    scale: review.scale
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Products);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,2013,3826,1399,5675,8250,3146,4117,3890,8558,8616,9774,2888,179], function() { return __webpack_exec__(16161); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);